import $ from '@vaersaagod/tools/Dom';
import BaseComponent from '../lib/BaseComponent';
import lodash_get from 'lodash/get';

export class IframeResizer extends BaseComponent {
    init() {
        window.addEventListener('message', this.onIframeResize.bind(this));
        this.lastHeight = 0;
        this.iframe = $(this.el).find('iframe');
        this.iframe.attr('src', this.iframe.data('src'));
    }

    getIframeOrigin() {
        const parser = document.createElement('a');
        parser.href = this.iframe.attr('src');
        return `${parser.protocol}//${parser.host}`;
    }

    onIframeResize(e) {
        if (e.origin !== this.getIframeOrigin()) return;
        const height = parseInt(lodash_get(e, 'data.height', 0), 10);
        if (height !== this.lastHeight) {
            this.lastHeight = height;
            this.iframe.height(height);
        }
    }
}

export default IframeResizer;



// WEBPACK FOOTER //
// ./src/js/components/IframeResizer.js